import { useMutation } from "urql";

import { CreateClikDataDocument } from "../../../graphql/generated.ts";

export function useCreateClikData() {
  return useMutation(CreateClikDataDocument);
}
